import { configureStore } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";

import reducer from "./reducer";
import saga from "./saga";

// contexts
import router from "../router";

const sagaMiddleware = createSagaMiddleware();

sagaMiddleware.setContext({ router });

const rootSaga = configureStore({
  reducer: reducer,

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(sagaMiddleware),
});

export default rootSaga;

sagaMiddleware.run(saga);
